<template>
  <v-select
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="claimProductDuplicationTypes"
    item-value="name"
    item-text="longDescription"
    clearable
    return-object
  >
  </v-select>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "ClaimProductDuplicationTypeField",
  props: {
    value: [Object, String]
  },
  data: () => ({
    claimProductDuplicationTypes: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    }
  },
  mounted() {
    ApiService.get("/api/types/claimProductDuplications").then(({ data }) => {
      this.claimProductDuplicationTypes = data;
    });
  }
};
</script>
